import { ComponentPropsWithoutRef, FC } from 'react';

type PaperIconProps = ComponentPropsWithoutRef<'svg'>;

export const PaperIcon: FC<PaperIconProps> = ({ fill, ...props }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            {...props}
        >
            <path
                d="M13.0961 3.37053L10.6927 0.913005C10.4349 0.649385 10.0854 0.5 9.72161 0.5H3.875C3.11589 0.502929 2.5 1.13269 2.5 1.9089V14.094C2.5 14.8702 3.11589 15.5 3.875 15.5H12.125C12.8841 15.5 13.5 14.8702 13.5 14.094V4.36643C13.5 3.99443 13.3539 3.63415 13.0961 3.37053ZM12.4487 4.03544C12.5089 4.09695 12.549 4.17018 12.569 4.2522H9.83333V1.45489C9.91354 1.4754 9.98516 1.5164 10.0453 1.57791L12.4487 4.03544ZM12.125 14.5627H3.875C3.62292 14.5627 3.41667 14.3518 3.41667 14.094V1.9089C3.41667 1.65114 3.62292 1.44025 3.875 1.44025H8.91667V4.48653C8.91667 4.8761 9.22318 5.18951 9.60417 5.18951H12.5833V14.094C12.5833 14.3518 12.3771 14.5627 12.125 14.5627ZM10.75 7.41564V7.64997C10.75 7.84329 10.5953 8.00146 10.4062 8.00146H5.59375C5.40469 8.00146 5.25 7.84329 5.25 7.64997V7.41564C5.25 7.22232 5.40469 7.06415 5.59375 7.06415H10.4062C10.5953 7.06415 10.75 7.22232 10.75 7.41564ZM10.75 9.29028V9.5246C10.75 9.71793 10.5953 9.8761 10.4062 9.8761H5.59375C5.40469 9.8761 5.25 9.71793 5.25 9.5246V9.29028C5.25 9.09695 5.40469 8.93878 5.59375 8.93878H10.4062C10.5953 8.93878 10.75 9.09695 10.75 9.29028ZM10.75 11.1649V11.3992C10.75 11.5926 10.5953 11.7507 10.4062 11.7507H5.59375C5.40469 11.7507 5.25 11.5926 5.25 11.3992V11.1649C5.25 10.9716 5.40469 10.8134 5.59375 10.8134H10.4062C10.5953 10.8134 10.75 10.9716 10.75 11.1649Z"
                fill={fill ?? 'currentColor'}
            />
        </svg>
    );
};
